import { render } from "./AkanDimulaiMeeting.vue?vue&type=template&id=553094b7"
import script from "./AkanDimulaiMeeting.vue?vue&type=script&lang=js"
export * from "./AkanDimulaiMeeting.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__